// src/utils/carriers.js — Maxula
// Suivi transporteur (best-effort, sans URL inventée). Deux niveaux :
//  1) DEEP-LINK : transporteurs au format de suivi public stable où le numéro
//     est pré-rempli dans l'URL (DHL, Aramex, FedEx, UPS, Chronopost).
//  2) PAGE      : transporteurs marocains dont seule la PAGE de suivi officielle
//     est connue (formulaire, numéro NON pré-remplissable de façon fiable). On
//     ouvre la page officielle et l'acheteur colle son numéro (bouton « Copier »).
// Tout transporteur absent des deux tables -> null (l'UI n'affiche que la copie).

const norm = (s) => String(s || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

// 1) Deep-link : numéro pré-rempli dans l'URL.
const DEEPLINK = [
  { match: 'dhl', url: (tn) => `https://www.dhl.com/ma-en/home/tracking/tracking-express.html?tracking-id=${encodeURIComponent(tn)}` },
  { match: 'aramex', url: (tn) => `https://www.aramex.com/track/results?ShipmentNumber=${encodeURIComponent(tn)}` },
  { match: 'fedex', url: (tn) => `https://www.fedex.com/fedextrack/?trknbr=${encodeURIComponent(tn)}` },
  { match: 'ups', url: (tn) => `https://www.ups.com/track?tracknum=${encodeURIComponent(tn)}` },
  { match: 'chronopost', url: (tn) => `https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=${encodeURIComponent(tn)}` },
];

// 2) Page officielle de suivi (numéro à coller).
const PAGE = [
  { match: 'amana', url: 'https://bam-tracking.barid.ma/' },
  { match: 'barid', url: 'https://bam-tracking.barid.ma/' },
  { match: 'poste', url: 'https://bam-tracking.barid.ma/' },
  { match: 'ctm', url: 'https://ctm-messagerie.ma/fr/suivi-du-colis' },
];

// Renvoie { url, prefilled } ou null. prefilled=true => le numéro est dans l'URL.
export function carrierTracking(carrier, trackingNumber) {
  const c = norm(carrier);
  if (!c) return null;
  const tn = String(trackingNumber || '').trim();
  const deep = DEEPLINK.find((x) => c.includes(x.match));
  if (deep && tn) return { url: deep.url(tn), prefilled: true };
  const page = PAGE.find((x) => c.includes(x.match));
  if (page) return { url: page.url, prefilled: false };
  return null;
}

// Compat : ancienne signature — renvoie une URL pré-remplie, ou null sinon.
export function carrierTrackingUrl(carrier, trackingNumber) {
  const r = carrierTracking(carrier, trackingNumber);
  return r && r.prefilled ? r.url : null;
}
